import WeBranches from './We.Branches.vue'

export default WeBranches
